import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules} from '@angular/router';
import { HomeRedirectGuard } from './home-redirect-guard';
import { ClientGuard } from './client-guard';
import { AccountantGuard } from './accountant-guard';
import { AdminOrAuditorGuard } from './admin-or-auditor-guard';
import { LoggedInGuard } from './logged-in-guard';

export const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  {
    path: "home",
    canActivate: [HomeRedirectGuard],
    loadChildren: () => import('./layout/home/home.module').then(m => m.HomeModule)
  },
  {
    path: "settings",
    canMatch: [LoggedInGuard],
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: "administration",
    canMatch: [AdminOrAuditorGuard],
    loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule)
  },
  {
    path: "client",
    canMatch: [ClientGuard],
    loadChildren: () => import('./client/client.module').then(m => m.ClientModule)
  },
  {
    path: "accountant",
    canMatch: [AccountantGuard],
    loadChildren: () => import('./accountant/accountant.module').then(m => m.AccountantModule)
  },
  {
    path: "reports",
    canMatch: [AdminOrAuditorGuard],
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: "onboarding",
    canMatch: [LoggedInGuard],
    loadComponent: () => import('./onboarding/onboarding.component').then(c => c.OnboardingComponent)
  },
  {
    path: "access-denied",
    loadComponent: () => import('./layout/access-denied/access-denied.component').then(c => c.AccessDeniedComponent)
  }

];
 
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }